import httpRequest from '@/utils/request.js'

export const monitorRange = (params = {}) => httpRequest.httpGet({
  url: '/service/monitorRange/lst', params: {
    ...params
  }
})



export const getExtends = (params = {}) => httpRequest.httpGet({
  url: '/service/atomCarrierExtend/getExtends', params: {
    ...params
  }
})
export const historygetPg = (params = {}) => httpRequest.httpGet({
  url: '/service/history/getPg', params: {
    ...params
  }
})
export const getTypes = (params = {}) => httpRequest.httpGet({
  url: '/service/atomCarrierExtend/getTypes', params: {
    ...params
  }
})
export const getMaintain = (params = {}) => httpRequest.httpGet({
  url: '/service/maintain/getMaintain', params: {
    ...params
  }
})
export const maintainTypes = (params = {}) => httpRequest.httpGet({
  url: '/service/maintain/getTypes', params: {
    ...params
  }
})
export const getLineData = (params = {}) => httpRequest.httpGet({
  url: '/service/history/getLineData', params: {
    ...params
  }
})

export const increaseds = (data, loadingOptions) => httpRequest.httpPost('/service/monitorRange/add', data, loadingOptions)

// 架构添加

export const saveScene = (data, loadingOptions) => httpRequest.httpPost('/service/atomCarrierExtend/save', data, loadingOptions)
export const saveMaintain = (data, loadingOptions) => httpRequest.httpPost('/service/maintain/save', data, loadingOptions)

// 架构更新
export const uptScene = (data, loadingOptions) => httpRequest.httpPut('/service/scene/uptScene', data)

// 编辑监测区间
export const editmonitors = (data, loadingOptions) => httpRequest.httpPut('/service/monitorRange/upt', data)





// 删除
export const delmonitors = (data, loadingOptions) => httpRequest.httpdelete('/service/monitorRange/del', data, loadingOptions)

// 架构删除
export const delScene = (data, loadingOptions) => httpRequest.httpdelete('/service/scene/delScene', data, loadingOptions)
